let listeners = new Map();

export class EventEmitter {

	static on(eventName, callback) {
		EventEmitter.addListener(eventName, callback);
	}

	static emit(eventName, ...args) {
		let localListeners = listeners.get(eventName);

		if (localListeners && localListeners.length) {
			localListeners.forEach((listener) => {
				listener(...args);
			});
			return true;
		}
		return false;
	}

	static off(eventName) {
		EventEmitter.removeListener(eventName);

	}

	static addListener(eventName, callback) {
		listeners.has(eventName) || listeners.set(eventName, []);
		listeners.get(eventName).push(callback);

	}

	static removeListener(eventName) {

		let localListeners = listeners.get(eventName);
		let index;

		if (localListeners && localListeners.length) {
			index = localListeners.reduce((i, listener, index) => {
				return typeof listener === 'function' ? i = index : i;
			}, -1);
			if (index > -1) {
				localListeners.splice(index, 1);
				listeners.set(eventName, localListeners);
				return true;
			}
		}

		return false;
	}

}
